import { useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';

import AtomFlex from '../../../components/atoms/AtomFlex';
import AtomGrid from '../../../components/atoms/AtomGrid';
import { styleConfigs } from '../../../components/resources/styleConfigs';
import DrawerWrapper from '../../../components/wrappers/DrawerWrapper';

export const DrawerContainerStyled = styled(AtomGrid)(() => ({
  flexShrink: 0,
  [useTheme().breakpoints.up('lg')]: {
    width: styleConfigs.dimensions.width280,
  },
}));

export const DrawerDesktopStyled = styled(DrawerWrapper)(() => ({
  display: 'none',
  [useTheme().breakpoints.up('lg')]: {
    display: 'flex',
  },
}));

export const DrawerMobileStyled = styled(DrawerWrapper)(() => ({
  [useTheme().breakpoints.up('lg')]: {
    display: 'flex',
  },
}));

export const MainContainerSidebarStyled = styled(AtomFlex)({
  height: styleConfigs.dimensions.percent100,
  display: 'flex',
  justifyContent: 'space-between',
  paddingBlockEnd: styleConfigs.marginPadding.custom80,
});

export const LogoContainerStyled = styled(AtomGrid)({
  display: 'flex',
  justifyContent: 'center',
  paddingBlock: styleConfigs.marginPadding.custom32,
  width: styleConfigs.dimensions.percent95,
});
